module.exports = __webpack_public_path__ + "img/referral-link-svg.80500553.svg";